import { IClearProps } from "./Interfaces";
import { Button } from "react-bootstrap";

export function ClearButton({ clear, onClear }: IClearProps) {
  return (
    <Button
      className={`btn btn-primary custom-margin`}
      onClick={() => onClear(!clear)}
    >
      Clear
    </Button>
  );
}
